// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__i-h+A","filters_close":"FiltersBlock_filters_close__iWeC5"};